import { createElement, useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { useClickAway, useIsomorphicLayoutEffect } from 'ahooks';
import classNames from 'classnames';
import { getPlacement } from './tool';
import './index.scss';
const classPrefix = `au-popover`;
const ColorfulPopover = props => {
    const { defaultVisible, placement = 'BOTTOM', title = '标题', content = '内容', children, borderWidth = 1, borderColor, backgroundColor } = props;
    const [visible, setVisible] = useState(defaultVisible);
    const [targetElement, setTargetElement] = useState(null);
    const targetRef = useRef(null);
    const floatingRef = useRef(null);
    const arrowRef = useRef(null);
    const arrowBeforeRef = useRef(null);
    useEffect(() => {
        setVisible(defaultVisible);
    }, [defaultVisible]);
    useIsomorphicLayoutEffect(() => {
        const floating = floatingRef.current;
        const arrowElement = arrowRef.current;
        const arrowBefore = arrowBeforeRef.current;
        Object.assign(floating.style, { backgroundColor, borderWidth: `${borderWidth}px`, borderColor });
        Object.assign(arrowElement.style, { backgroundColor: borderColor });
        Object.assign(arrowBefore.style, { backgroundColor });
    }, [backgroundColor, borderWidth, borderColor]);
    function update() {
        const target = targetRef.current ?? null;
        const floating = floatingRef.current;
        const arrowElement = arrowRef.current;
        const arrowBefore = arrowBeforeRef.current;
        setTargetElement(target);
        const popDom = document.querySelector(".au-popover-inner");
        const popWidth = popDom.offsetWidth;
        const popHeight = popDom.offsetHeight;
        if (popWidth) {
            const pos = getPlacement(target, popWidth, popHeight, placement);
            let popObj;
            let arrowObj;
            let arrowBeforeObj;
            Object.keys(pos).forEach(key => {
                if (key === 'pop') {
                    popObj = pos[key];
                }
                else if (key === 'arrow') {
                    arrowObj = pos[key];
                }
                else {
                    arrowBeforeObj = pos[key];
                }
            });
            if (popObj) {
                Object.assign(floating.style, { ...popObj });
                Object.assign(arrowElement.style, { ...arrowObj });
                Object.assign(arrowBefore.style, { ...arrowBeforeObj });
            }
        }
    }
    useEffect(() => {
        visible && update();
    }, [visible, placement]);
    useEffect(() => {
        if (!targetElement)
            return;
        function handleClick(e) {
            setVisible(v => !v);
        }
        targetElement.addEventListener('click', handleClick);
        return () => {
            targetElement.removeEventListener('click', handleClick);
        };
    }, [targetElement]);
    useClickAway(() => {
        setVisible(false);
    }, [() => targetRef.current, floatingRef], ['click', 'touchmove']);
    const floating = (createElement("div", { className: classNames(classPrefix, {
            [`${classPrefix}-hidden`]: !visible,
        }) },
        createElement("div", { className: "au-popover-inner", ref: floatingRef },
            createElement("div", null,
                createElement("h4", null, title),
                content)),
        createElement("div", { className: "au-popover-arrow", ref: arrowRef }),
        createElement("div", { className: "au-popover-arrow-before", ref: arrowBeforeRef })));
    return (createElement(React.Fragment, null,
        createElement("div", { className: "au-popover-target", ref: targetRef }, children),
        createPortal(floating, document.body)));
};
ColorfulPopover.displayName = 'ColorfulPopover';
export default ColorfulPopover;
